/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type ViajeSuscriptoResponse = {
  state: number;
  value: number[];
};

export const viajeSuscripto = async (): Promise<number[]> => {
  try {
    const res = await apiClient.post<ViajeSuscriptoResponse>(
      Endpoints.ViajeSuscripto,
      {}
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
